module.exports = __webpack_public_path__ + "static/media/monoroom.50942592.png";